import { Icon } from "@iconify/react/dist/iconify.js";
import "../../../../assets/styles/memberLogin.css";
import { LineWave } from "react-loader-spinner";
import AlertComp from "../../../../Components/Atoms/AlertComp";
import { useAgenda } from "./agendaFunction";

const AgendaLoginPage = ({ myRef, dataPage }) => {
  const { isLoading, alertValue, dataAgenda, handleCloseAlert } = useAgenda();
  return (
    <div
      className="page absolute duration-1000 origin-left transition transform  
                w-calendar h-[calc(100%-100px)]  rounded-[30px] bg-white shadow-lg flex flex-col justify-center items-center
            "
      data-page={dataPage}
      ref={myRef}
    >
      {isLoading && (
        <div className=" pt-[9rem] fixed inset-0 z-[40] flex justify-center items-center ">
          <LineWave
            visible={true}
            height="200"
            width="200"
            color="#5B99C2"
            ariaLabel="line-wave-loading"
            wrapperStyle={{}}
            wrapperClass=""
            firstLineColor=""
            middleLineColor=""
            lastLineColor=""
          />
        </div>
      )}

      <AlertComp
        isOpen={alertValue.show}
        onClose={handleCloseAlert}
        text={alertValue.text}
        subText={alertValue.subText}
        color={alertValue.color}
        icon={alertValue.icon}
      />

      <div className="front absolute front w-full h-full flex flex-col  text-black p-[15px] overflow-hidden">
        <div className="w-full text-center font-bold text-2xl  2xl:text-3xl mt-marginTopLogin mb-5 ">
          Agenda Acara
        </div>
        <div className="w-full h-full">
          <table className="table-agenda  w-full">
            <thead>
              <tr>
                <th className="w-[20%] text-left">Tanggal</th>
                <th className="w-[80%] text-left">Agenda</th>
              </tr>
            </thead>
            <tbody>
              {dataAgenda.map((item, index) => {
                // Mengonversi tanggal ke format yang diinginkan
                const eventDate = new Date(item.tanggal);
                const month = eventDate
                  .toLocaleString("default", { month: "short" })
                  .toUpperCase();
                const day = eventDate.getDate();

                return (
                  <tr key={index} className="text-xs">
                    <td className="align-center">
                      <div className="w-[100px]">
                        <div
                          className={`bg-gradient-to-r from-[${
                            item.color_label || "#64B5FF"
                          }] to-[${
                            item.color_label || "#6B95FF"
                          }] text-white py-[1px] text-center rounded-t-[5px]`}
                        >
                          {month}
                        </div>
                        <div className="text-[#555555] bg-[#EFEFEF] h-[50px] rounded-b-[5px] flex flex-row justify-center items-center text-[20px] font-medium">
                          {day}
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="text-[#6B95FF] font-[700] text-[18px] 2xl:text-[20px] mb-2">
                        {item.nama}
                      </div>
                      <div className="flex flex-row text-[#616161] text-[16px] font-normal items-center">
                        <div className="">
                          <Icon icon="fluent:clock-20-regular" fontSize={20} />
                        </div>
                        <div className="ml-[10px] flex flex-wrap gap-2 items-center">
                          <div>
                            {item.start_time} - {item.end_time} WIB
                          </div>
                          <div className="text-sky-600">|</div>
                          {item.lokasi && (
                            <div className="">Lokasi: {item.lokasi}</div>
                          )}
                        </div>
                      </div>
                      {/* <div className="text-[16px] font-light mt-[4px] text-ellipsis overflow-hidden">
                        <div
                          dangerouslySetInnerHTML={{ __html: item.description }}
                        ></div>
                      </div> */}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
export default AgendaLoginPage;
